import { ru } from './ru'
import { en } from './en'
const location = {
  en,
  ru,
}

export default location
